import { Flex, Badge } from '@radix-ui/themes';

import { TransactionStatus } from '../../types';

type BadgeColor =
  | 'gray'
  | 'gold'
  | 'bronze'
  | 'brown'
  | 'yellow'
  | 'amber'
  | 'orange'
  | 'tomato'
  | 'red'
  | 'ruby'
  | 'crimson'
  | 'pink'
  | 'plum'
  | 'purple'
  | 'violet'
  | 'iris'
  | 'indigo'
  | 'blue'
  | 'cyan'
  | 'teal'
  | 'jade'
  | 'green'
  | 'grass'
  | 'lime'
  | 'mint'
  | 'sky';

const badges: {
  [key in TransactionStatus]: { color: BadgeColor; label: string };
} = {
  [TransactionStatus.Confirmed]: { color: 'green', label: 'Confirmed' },
  [TransactionStatus.Failed]: { color: 'red', label: 'Failed' },
  [TransactionStatus.Pending]: { color: 'amber', label: 'Pending' },
};

const TransactionStatusBadge = ({ status }: { status: TransactionStatus }) => {
  const badge = badges[status];

  return (
    <Flex gap="2" height="100%" align="center">
      <Badge radius="large" color={badge.color}>
        {badge.label}
      </Badge>
    </Flex>
  );
};

export default TransactionStatusBadge;
